// useMemo-equivalent shallow single-slot memoizer for non-hook contexts

function shallowEqualArgs(prev, next) {
	if (prev.length !== next.length) {
		return false;
	}

	for (let i = 0; i < prev.length; i++) {
		if (prev[i] !== next[i]) {
			return false;
		}
	}

	return true;
}

function memoizeOne(fn) {
	let lastArgs = null;
	let lastResult;
	let hasResult = false;

	return function (...args) {
		if (hasResult && shallowEqualArgs(lastArgs, args)) {
			return lastResult;
		}

		lastResult = fn.apply(this, args);
		lastArgs = args;
		hasResult = true;

		return lastResult;
	};
}

module.exports = memoizeOne;
